'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const StyledButton = styled__default["default"].button.withConfig({
  componentId: "sc-xmbkg7-0"
})(["padding:32px;background-color:hotpink;font-size:24px;border-radius:4px;color:black;font-weight:bold;&:hover{color:white;}"]);
const SubmitButton = () => {
  return /*#__PURE__*/React__default["default"].createElement(StyledButton, {
    onClick: () =>
    // eslint-disable-next-line no-console
    console.log('Submit')
  }, "Submit Return");
};

exports["default"] = SubmitButton;
